import { createSelector } from 'reselect';
import currentSessionSelector from './session';

export default createSelector(currentSessionSelector, (session) =>
  session ? session.sessionInfo.teamInfo : undefined
);
